import React from 'react';
import { Tooltip, Card } from 'antd';
import clsx from 'clsx';

const TextAreaRender = (props) => {
    const { text, className, style } = props;

    return !!text && (
        <Tooltip
            destroyTooltipOnHide={{ keepParent: false }}
            placement="bottom"
            overlayClassName="table-tooltip"
            title={!!text && (
                <Card
                    className="text-white bg-gray-dark02"
                    bodyStyle={{ padding: '4px 8px' }}
                >
                    <div className="whitespace-pre-line">
                        {text}
                    </div>
                </Card>
            )}
        >
            <span
                className={clsx(
                    'whitespace-nowrap',
                    { 'px-2': !className?.includes('px') },
                    className
                )}
                style={style}
            >
                {typeof text === 'string' && (
                    `${text?.split('\n')[0]}${text?.split('\n')[1] ? '...' : ''}`
                )}
            </span>
        </Tooltip>
    );
};

export default TextAreaRender;
